import {FormView} from '../../src/components/_views/configurable/FormView';
import UserRolesForm from '../../src/components/_forms/UserRolesForm';
import {withRouterApi} from '../../src/HOCs/withRouterApi';
import {FormViewProps} from '../../src/@types/components/FormViewProps';
import {UserRolesFormModel} from '../../src/@types/components/UserRolesForm';

export class UserRolesUpdateFormPage extends FormView<UserRolesFormModel> {
    protected getFormComponent() {
        return UserRolesForm as any;// todo: somehow fix typescript error
    }
}

export default UserRolesUpdateFormPage.getStoreConnector()(withRouterApi<FormViewProps>(UserRolesUpdateFormPage));
